.scrim { position: fixed; inset: 0; background: var(--scrim); z-index: 20; }
.panel { position: fixed; top: 0; right: 0; bottom: 0; width: 560px; z-index: 21; display: flex; flex-direction: column; background: var(--paper); border-left: var(--border-panel); }
.panel:focus { outline: none; }
.body > * { flex: none; }
.body { flex: 1; min-height: 0; overflow-y: auto; display: flex; flex-direction: column; gap: 24px; padding: 32px 36px; }
.done, .phoneOnly { display: none; }
.head { display: flex; justify-content: space-between; align-items: flex-start; }
.headText { display: flex; flex-direction: column; gap: 6px; }
.eyebrow { margin: 0; font-family: var(--font-mono); font-size: 10px; letter-spacing: 1.4px; color: var(--hot); }
.title { margin: 0; font-family: var(--font-cond); font-size: 44px; font-weight: 900; letter-spacing: -1.5px; line-height: 1; }
.zone { height: 240px; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 10px; background: var(--pink); border: var(--border-panel); box-shadow: var(--shadow-panel); cursor: pointer; }
.zone[data-over='true'] { background: var(--hot); }
.zoneTitle { font-family: var(--font-cond); font-size: 44px; font-weight: 900; letter-spacing: -1.5px; }
.zoneSub { font-family: var(--font-mono); font-size: 10px; letter-spacing: 1.2px; }
.queue { border: var(--border-hair); }
.queueHead { display: flex; justify-content: space-between; align-items: center; padding: 14px 20px; border-bottom: var(--border-hair); font-family: var(--font-mono); font-size: 10px; letter-spacing: 1.4px; color: var(--text-secondary); }
.clear { font-family: var(--font-mono); font-size: 10px; letter-spacing: 1.2px; color: var(--ink); }
.rows { margin: 0; padding: 0; list-style: none; }
.row { position: relative; display: grid; grid-template-columns: 110px minmax(0, 1fr) auto; grid-template-areas: 'chip file retry' 'chip msg retry'; align-items: center; column-gap: 16px; row-gap: 3px; padding: 14px 20px; border-bottom: var(--border-hair); }
.row > button { grid-area: retry; }
.chip { grid-area: 1 / 1; text-align: center; padding: 5px 8px; font-family: var(--font-mono); font-size: 9px; letter-spacing: 1px; color: var(--ink); }
.chipStack { grid-area: chip; align-self: center; display: grid; }
.chip[data-tone='green'] { background: var(--green); }
.chip[data-tone='amber'] { background: var(--amber); }
.chip[data-tone='hot'] { background: var(--hot); }
.chip[data-leaving='true'] { animation: chipOut 160ms var(--ease-in) forwards; }
.chip[data-entering='true'] { animation: chipIn 160ms var(--ease-out); }
@keyframes chipOut { to { opacity: 0; } }
@keyframes chipIn { from { opacity: 0; } }
.row[data-flash='true']::after { content: ''; position: absolute; inset: 0; background: var(--green); opacity: 0; pointer-events: none; animation: rowFlash 280ms var(--ease-out); }
@keyframes rowFlash { 30% { opacity: 0.5; } to { opacity: 0; } }
.info { display: contents; }
.file { grid-area: file; min-width: 0; font-family: var(--font-mono); font-size: 12px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.message { grid-area: msg; font-size: 12px; color: var(--text-secondary); }
.note { margin: 0; font-size: 13px; line-height: 1.5; color: var(--text-secondary); }

@media (max-width: 1023px) {
  .panel { width: 480px; }
}

@media (max-width: 639px) {
  .scrim { z-index: 40; }
  .panel { position: static; flex: 1; min-height: 0; width: auto; border-left: 0; background: transparent; gap: 14px; }
  .body { gap: 16px; padding: 0; }
  .title { font-size: 30px; letter-spacing: -1px; }
  .zone { height: 140px; gap: 8px; box-shadow: 4px 4px 0 var(--ink); }
  .zone svg { width: 26px; height: 26px; }
  .zoneTitle { font-size: 32px; letter-spacing: -1px; }
  .zoneSub { letter-spacing: 1px; }
  .desktopOnly { display: none; }
  .phoneOnly { display: inline; }
  .queueHead { height: 44px; padding: 0 14px; letter-spacing: 1.2px; }
  .row { grid-template-columns: minmax(0, 1fr) auto; grid-template-areas: 'chip retry' 'file retry' 'msg retry'; justify-items: start; row-gap: 5px; padding: 12px 14px; column-gap: 12px; }
  .row:nth-child(even) { background: var(--paper-2); }
  .chip { padding: 3px 7px; }
  .file { white-space: normal; overflow-wrap: anywhere; }
  .message { line-height: 1.4; }
  .row > button { width: 72px; padding: 0; letter-spacing: 0.6px; }
  .done { display: flex; align-items: center; justify-content: center; flex: none; height: 52px; background: var(--ink); color: var(--paper); font-family: var(--font-mono); font-size: 12px; letter-spacing: 1.2px; }
}
